import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAvatarLocation = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18 22C15.176 22 12.671 22.638 11.025 23.193C9.81 23.604 9 24.749 9 26.032V30C9 30 16.958 30 17 30",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 22C15.239 22 13 18.761 13 16V15C13 12.239 15.239 10 18 10C20.761 10 23 12.239 23 15V16C23 18.761 20.761 22 18 22Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 24.817C31 27.183 27 31 27 31C27 31 23 27.183 23 24.817C23 22.374 25.08 21 27 21C28.92 21 31 22.374 31 24.817Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.5 25C27.5 25.2761 27.2761 25.5 27 25.5C26.7239 25.5 26.5 25.2761 26.5 25C26.5 24.7239 26.7239 24.5 27 24.5C27.2761 24.5 27.5 24.7239 27.5 25Z",
			stroke: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgAvatarLocation);
export default ForwardRef;
